export default {
  data: function data() {
    return {
      showPage: true
    };
  } // mounted () {
  //   setTimeout(() => {
  //     this.showPage = true
  //   }, 600)
  // },
  // beforeDestroy () {
  //   this.showPage = false
  // },
};